import React from 'react';
import { Icon } from '@upsales/components';
import T from 'Components/Helpers/translate';
import type { LookupQueryKind } from 'App/shadcn/pages/ProspectingTools/Lookup/lookupApi';
import { isPersonKind } from './lookupQueryKind';
import { SupersearchProspectingHeader } from './SupersearchProspectingResults';

export type RecognisedKind = Exclude<LookupQueryKind, 'unknown'>;

const LABEL_KEYS: Record<RecognisedKind, string> = {
	linkedinUrl: 'navbar.quickSearch.lookup.linkedinUrl',
	linkedinCompany: 'navbar.quickSearch.lookup.linkedinCompany',
	email: 'navbar.quickSearch.lookup.email',
	domain: 'navbar.quickSearch.lookup.domain',
	orgNumber: 'navbar.quickSearch.lookup.orgNumber',
	nameAndCompany: 'navbar.quickSearch.lookup.nameAndCompany'
};

type Props = {
	kind: RecognisedKind;
	onChoose: () => void;
};

/**
 * Supersearch's prospecting section offering "Look up this …" (WEB-13132). Its row is a
 * `SupersearchResultRow`, so Tab / the arrows reach it and Enter clicks it like any other row. Only
 * choosing it runs a lookup: one can spend AI credits, so it is never preselected and Enter alone
 * never runs it (WEB-13618).
 */
const SupersearchLookup = ({ kind, onChoose }: Props) => (
	<div className="supersearch-prospecting">
		<SupersearchProspectingHeader />
		<button
			type="button"
			className="SupersearchResultRow supersearch-lookup"
			onClick={onChoose}
			data-test-id="supersearch-lookup"
		>
			<Icon name="search" />
			<span className="supersearch-lookup__text">
				<span className="supersearch-lookup__label">{T(LABEL_KEYS[kind])}</span>
				<span className="supersearch-lookup__hint">
					{isPersonKind(kind)
						? T('navbar.quickSearch.lookup.hint.person')
						: T('navbar.quickSearch.lookup.hint.company')}
				</span>
			</span>
		</button>
	</div>
);

export default SupersearchLookup;
